import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemTypeResponse } from 'src/app/core/models/system-type response';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SystemTypesApiService {
    baseUrl: string = environment.apiUrl;

    systemTypesUrlSuffix = 'v1/system_types';
    constructor(private httpClient: HttpClient) {}

    getSystemTypes(): Observable<SystemTypeResponse[]> {
        return this.httpClient.get<SystemTypeResponse[]>(`${this.baseUrl}${this.systemTypesUrlSuffix}`);
    }
}
